'use client'

import Link from 'next/link'

import { ImageForLanguage } from '@/legacy-src/components/languagePicker/LanguagePickerDropdown'
import { DropdownMenuItem } from '@/legacy-src/components/ui/dropdown-menu'
import { locales } from '@/legacy-src/constants/locale.constants'
import { getFullDomain, getLocaleDisplayName, getLocaleDomain } from '@/legacy-src/utilities/languagesConfig'

import { useLocalizedLanguageTargets } from '@/src/domains/seo/hooks/useLocalizedLanguageTargets'

const LanguagePickerList = () => {
  const localizedTargets = useLocalizedLanguageTargets()

  return (
    <>
      {locales.map((locale) => {
        const url = localizedTargets[locale] ?? getFullDomain(locale)
        const domain = getLocaleDomain(locale)
        const text = getLocaleDisplayName(locale)

        return (
          <DropdownMenuItem
            asChild
            key={`${locale}-${text}`}
            className="flex min-w-[200px] items-center px-3 py-1 text-xs font-bold uppercase text-petrol-500 outline-none hover:no-underline focus:text-peach-400"
          >
            <Link href={url}>
              <ImageForLanguage
                language={{
                  text,
                  domain,
                }}
              />
              <div>{text}</div>
            </Link>
          </DropdownMenuItem>
        )
      })}
    </>
  )
}

export default LanguagePickerList
